export default 
    (id, isRoot, bundleName, branch) => {
        let b = {
            active: true,
            id: id,
            isRoot: isRoot,
            children: [],
            type: 'list',
            listName: bundleName,
            items: [],
            branch: branch,
            dirt: 0,
            hasDirtyBundles: false,
            collabId: null,
            aliasTgtId: null,
            isAlias: 0,
            isInbox: 0,
            isPublic: 0,
            itemsLoaded: true
        }

        return b
    }
